export const CATEGORIES = [
  { label: 'Clientes', value: 'Clientes' },
  { label: 'Segmentos', value: 'Segmentos' },
  { label: 'CNAE Primário', value: 'CNAE Primário' },
  { label: 'CNAE Seções', value: 'CNAE Seções' },
  { label: 'Geografia', value: 'Geografia' },
  { label: 'Porte', value: 'Porte' },
  { label: 'Idade', value: 'Idade' },
  { label: 'Relacionamento', value: 'Relacionamento' },
  { label: 'PEP', value: 'PEP' },
  { label: 'Listas', value: 'Listas' },
  { label: 'Processos judiciais', value: 'Processos judiciais' },
  { label: 'Estrutura', value: 'Estrutura' },
  { label: 'Status', value: 'Status' },
  { label: 'Representante legal', value: 'legalRepresentative' },
  { label: 'Social address', value: 'socialAddress' },
  { label: 'Commercial address', value: 'commercialAddress' },
  { label: 'Tipo de documento', value: 'documentType' },
  { label: 'Nacionalidad', value: 'nationality' },
  { label: 'País de nacimiento', value: 'countryOfBirth' },
  { label: 'Profesión', value: 'profession' },
  { label: 'Produtos', value: 'produtos' },
  { label: 'Actividad económica', value: 'activityBusiness' },
  { label: 'Ocupación', value: 'ocupation' },
  { label: 'Representante legal - Tipo de identificación', value: 'shareholdersTipoIdentificación' },
  { label: 'Representante legal - País de nacimiento', value: 'shareholdersBirthPlace' },
  { label: 'Representante legal - Nacionalidad', value: 'shareholdersNationality' },
  { label: 'Representante legal - Ciudad', value: 'shareholdersCity' },
  { label: 'Ingresos mensuales', value: 'ingresosMensuales' },
  { label: 'Monto mensual estimado transaccional', value: 'montoMensualEstimado' },
  { label: 'Ciudad', value: 'city' },
  { label: 'Origen de ingresos', value: 'origenIngresos' },
  { label: 'Monto mensual estimado transaccional', value: 'transactionalAmount' },
  { label: 'Ganancias', value: 'earnings' },
  { label: 'IVA', value: 'iva' },
  { label: 'Cheques', value: 'checks' },
  { label: 'Deudores', value: 'debtors' },
]

export const customCombinators = [
  { name: 'and', label: 'AND' },
  { name: 'or', label: 'OR' },
  { name: 'none', label: '---' },
]

/**
 * These are the methods that will execute to check the result of each point of data
 * To check on each item from a result of type array use methods that start with 'any_' or 'all_'
 *
 * @see https://github.com/gueno-repositories/gueno2.0/blob/master/src/riskmatrix/riskmatrix.service.ts#L70
 */
export const customOperators = [
  { name: 'includes', input: 'string' },
  { name: 'includes_any', input: 'list' },
  { name: 'includes_all', input: 'list' },
  { name: 'includes_any_value', input: 'list' },
  { name: 'any_includes', input: 'string' },
  { name: 'any_not_includes', input: 'string' },
  { name: 'any_not_equals', input: 'string' },
  { name: 'any_includes_any', input: 'list' },
  { name: 'all_includes_all', input: 'list' },
  { name: 'max_unique_values', input: 'number' },
  { name: 'is', input: 'boolean' },
  { name: 'any_is_number', input: 'number' },
  { name: 'equals', input: 'string' },
  { name: 'equals_number', input: 'number' },
  { name: 'less_than_number', input: 'number' },
  { name: 'less_equal_than_number', input: 'number' },
  { name: 'greater_than_number', input: 'number' },
  { name: 'greater_equal_than_number', input: 'number' },
  { name: 'between_inclusive_numbers', input: 'number_range' },
  { name: 'between_exclusive_numbers', input: 'number_range' },
  { name: 'is_size_description', input: 'list_sizes_descriptions' },
  { name: 'in_custom_list', input: 'custom_list' },
  { name: 'in_custom_list_composed', input: 'custom_list_composed' },
  { name: 'any_in_custom_list', input: 'custom_list' },
  { name: 'any_not_in_custom_list', input: 'custom_list' },
  { name: 'any_in_custom_list_composed', input: 'custom_list_composed' },
  { name: 'not_in_custom_list', input: 'custom_list' },
  { name: 'not_in_custom_list_composed', input: 'custom_list_composed' },
  { name: 'any_not_in_custom_list_composed', input: 'custom_list_composed' },
  { name: 'in_list', input: 'list' },
  { name: 'any_not_in_list', input: 'list' },
  { name: 'any_greater_than_number', input: 'number' },
  { name: 'any_greater_equal_than_number', input: 'number' },
  { name: 'any_less_than_number', input: 'number' },
  { name: 'any_less_equal_than_number', input: 'number' },
  { name: 'any_is', input: 'boolean' },
  { name: 'any_is_status', input: 'list_status' },
  { name: 'all_are_status', input: 'list_status' },
  { name: 'any_in_sanctions', input: 'list_sanctions_source' },
  { name: 'any_in_rejected_checks', input: 'list_rejected_checks_source' },
  { name: 'any_in_debtors_checks', input: 'list_debtors_checks_source' },
  { name: 'exists', input: 'boolean' },
  { name: 'is_employment_status', input: 'list_employment_status' },
]

export const riskMatrixAttributes = {
  KYB: {
    AR: [
      {
        name: 'company_activities_code',
        operators: ['any_includes_any', 'any_includes'],
      },
      {
        name: 'company_activities_description',
        operators: ['any_includes_any', 'any_includes'],
      },
      {
        name: 'company_business_segments',
        operators: ['any_includes', 'equals'],
      },
      {
        name: 'company_city',
        operators: ['in_custom_list', 'not_in_custom_list'],
        valueEditorType: 'select',
      },
      {
        name: 'company_country',
        operators: ['in_custom_list', 'not_in_custom_list'],
      },
      {
        name: 'company_cluster',
        operators: ['includes', 'equals'],
      },
      {
        name: 'company_products',
        operators: ['any_includes_any', 'any_includes'],
      },
      {
        name: 'registration_uptime_months',
        operators: [
          'less_than_number',
          'less_equal_than_number',
          'greater_than_number',
          'greater_equal_than_number',
          'between_inclusive_numbers',
          'between_exclusive_numbers',
        ],
        inputType: 'number',
      },
      {
        name: 'shareholders_qty',
        operators: [
          'less_than_number',
          'less_equal_than_number',
          'greater_than_number',
          'greater_equal_than_number',
          'between_inclusive_numbers',
          'between_exclusive_numbers',
        ],
        inputType: 'number',
      },
      {
        name: 'shareholders_pep_qty',
        operators: [
          'less_than_number',
          'less_equal_than_number',
          'greater_than_number',
          'greater_equal_than_number',
          'between_inclusive_numbers',
          'between_exclusive_numbers',
        ],
        inputType: 'number',
      },
      {
        name: 'rejected_checks_causals',
        operators: ['any_in_rejected_checks', 'any_includes_any', 'any_includes', 'in_custom_list'],
        valueEditorType: 'select',
      },
      {
        name: 'debtor_classification_situations',
        operators: ['any_in_debtors_checks', 'any_includes_any', 'any_includes', 'in_custom_list'],
        valueEditorType: 'select',
      },
      {
        name: 'iva_inscription_condition',
        operators: ['equals', 'not_equals'],
      },
      {
        name: 'ganancias_inscription_condition',
        operators: ['equals', 'not_equals'],
      },
    ],
    BR: [
      {
        name: 'blocked_cpfs',
        operators: ['greater_than_number', 'greater_equal_than_number', 'less_than_number', 'less_equal_than_number'],
      },
      {
        name: 'blocked_cnpj',
        operators: ['is'],
      },
      {
        name: 'shareholders_ages',
        operators: [
          'any_greater_than_number',
          'any_greater_equal_than_number',
          'any_less_than_number',
          'any_less_equal_than_number',
        ],
      },
      {
        name: 'border_town',
        operators: ['any_in_custom_list_composed', 'any_not_in_custom_list_composed'],
      },
      {
        name: 'area_code_different_from_address',
        operators: ['greater_than_number', 'greater_equal_than_number', 'less_than_number', 'less_equal_than_number'],
      },
      {
        name: 'shareholder_has_negative_media',
        operators: ['is'],
      },
      {
        name: 'category_types',
        operators: ['any_includes', 'any_includes_any', 'max_unique_values'],
      },
      {
        name: 'category_descriptions',
        operators: ['any_includes', 'any_includes_any'],
      },
      {
        name: 'main_category_descriptions',
        operators: ['equals', 'includes_any'],
      },
      {
        name: 'category_secondary_types_distint',
        operators: ['equals_number', 'greater_equal_than_number'],
      },
      {
        name: 'is_currently_pep',
        operators: ['is'],
        valueEditorType: 'select',
        values: [
          { name: 'true', value: true },
          { name: 'false', value: false },
        ],
      },
      {
        name: 'last_beneficiaries_pep_levels',
        operators: ['any_is_number'],
      },
      {
        name: 'last_beneficiaries_pep_history_times',
        operators: ['any_greater_than_number', 'any_greater_equal_than_number'],
      },
      {
        name: 'last_beneficiaries_japs',
        operators: ['any_includes_any'],
      },
      {
        name: 'last_beneficiaries_registration_status_names',
        operators: ['any_not_includes', 'any_not_equals', 'any_includes', 'any_not_in_list'],
      },
      {
        name: 'lawsuits_business',
        operators: ['any_includes', 'any_not_includes', 'any_includes_any', 'includes_any', 'any_not_equals'],
      },
      {
        name: 'lawsuits_business_count',
        operators: [
          'less_than_number',
          'less_equal_than_number',
          'greater_than_number',
          'greater_equal_than_number',
          'between_inclusive_numbers',
          'between_exclusive_numbers',
        ],
      },
      {
        name: 'has_lawsuit_court_type_business',
        operators: ['any_includes', 'any_includes_any', 'any_in_custom_list', 'any_not_in_custom_list'],
        valueEditorType: 'select',
      },
      {
        name: 'has_lawsuit_court_type_shareholders',
        operators: ['any_includes', 'any_includes_any', 'any_in_custom_list', 'any_not_in_custom_list'],
        valueEditorType: 'select',
      },
      {
        name: 'legal_organization_description',
        operators: ['equals', 'includes'],
      },
      {
        name: 'size_description',
        operators: ['is_size_description', 'in_list'],
      },
      {
        name: 'registration_uptime_months',
        operators: [
          'less_than_number',
          'less_equal_than_number',
          'greater_than_number',
          'greater_equal_than_number',
          'between_inclusive_numbers',
          'between_exclusive_numbers',
        ],
        inputType: 'number',
      },
      {
        name: 'company_city',
        operators: ['in_custom_list', 'not_in_custom_list'],
      },
      {
        name: 'company_country',
        operators: ['in_custom_list', 'not_in_custom_list'],
      },
      {
        name: 'company_cluster',
        operators: ['includes', 'equals'],
      },
      {
        name: 'company_business_segments',
        operators: ['any_includes_any', 'any_includes'],
      },
      {
        name: 'company_client_types',
        operators: ['any_includes_any', 'any_includes'],
      },
      {
        name: 'company_products',
        operators: ['any_includes_any', 'any_includes'],
      },
      {
        name: 'company_history_sanctions',
        operators: ['any_in_sanctions', 'any_includes_any', 'any_includes', 'in_custom_list'],
        valueEditorType: 'select',
      },
      {
        name: 'relationships_business_qty_no_qsa',
        operators: ['greater_than_number', 'greater_equal_than_number'],
      },
      {
        name: 'shareholders_person_administrator_active',
        operators: ['any_greater_than_number', 'any_greater_equal_than_number'],
      },
      {
        name: 'shareholders_business_qty_no_active',
        operators: ['greater_than_number', 'greater_equal_than_number'],
      },
      {
        name: 'shareholders_business_with_shareholder_business',
        operators: ['less_than_number', 'less_equal_than_number', 'greater_than_number', 'greater_equal_than_number'],
      },
      {
        name: 'shareholders_business_with_all_shareholders_persons',
        operators: ['less_than_number', 'less_equal_than_number', 'greater_than_number', 'greater_equal_than_number'],
      },
      {
        name: 'shareholders_countries',
        operators: ['any_in_custom_list', 'any_not_in_custom_list'],
      },
      {
        name: 'shareholders_pjs_countries',
        operators: ['any_in_custom_list', 'any_not_in_custom_list'],
      },
      {
        name: 'company_is_mei',
        operators: ['is'],
      },
      {
        name: 'last_beneficiaries_history_sanctions',
        operators: ['any_in_sanctions', 'any_includes_any', 'any_includes', 'in_custom_list'],
      },
      {
        name: 'situation',
        operators: ['equals', 'not_equals', 'in_list'],
      },
      {
        name: 'shareholders_status',
        operators: ['any_is_status'],
      },
      {
        name: 'shareholders_kyc_status',
        operators: ['any_not_includes', 'includes_any_value'],
        valueEditorType: 'select',
        values: ['APPROVED', 'REJECTED', 'PENDING', 'FLAGGED'].map((status) => ({ name: status, value: status })),
      },
      {
        name: 'total_share_capital',
        operators: [
          'less_than_number',
          'less_equal_than_number',
          'greater_than_number',
          'greater_equal_than_number',
          'between_inclusive_numbers',
          'between_exclusive_numbers',
        ],
      },
      {
        name: 'negative_media',
        operators: ['exists'],
      },
      {
        name: 'protestos',
        operators: ['exists'],
      },
      {
        name: 'incomeRange',
        operators: ['equals', 'includes', 'in_list'],
      },
      {
        name: 'incomeRange_v2',
        operators: ['equals', 'includes', 'in_list'],
      },
      {
        name: 'cnae_code',
        operators: ['equals', 'in_list'],
      },
      {
        name: 'cnae_codes_all',
        operators: ['any_includes', 'any_includes_any', 'any_in_custom_list', 'any_not_in_custom_list'],
      },
    ],
    CR: [
      {
        name: 'company_activity_name',
        operators: ['equals', 'in_custom_list', 'not_in_custom_list'],
      },
      {
        name: 'company_document_type',
        operators: ['equals', 'includes', 'in_list'],
      },
      {
        name: 'legal_representative_document_type',
        operators: ['equals', 'includes', 'in_list'],
      },
      {
        name: 'legal_representative_country_of_birth',
        operators: ['equals', 'in_custom_list', 'not_in_custom_list'],
      },
      {
        name: 'legal_representative_nationality',
        operators: ['equals', 'in_custom_list', 'not_in_custom_list'],
      },
      {
        name: 'company_income_name',
        operators: ['equals', 'in_custom_list', 'not_in_custom_list'],
      },
      {
        name: 'legal_representative_address_state_city',
        operators: ['in_custom_list_composed', 'not_in_custom_list_composed'],
      },
      {
        name: 'company_transactional_amount_name',
        operators: ['equals', 'in_custom_list'],
      },
      {
        name: 'is_currently_pep',
        operators: ['is'],
      },
      {
        name: 'is_reporting_entity',
        operators: ['is'],
      },
      {
        name: 'address_social_state_city',
        operators: ['in_custom_list_composed', 'not_in_custom_list_composed'],
      },
      {
        name: 'address_commercial_state_city',
        operators: ['in_custom_list_composed', 'not_in_custom_list_composed'],
      },
      {
        name: 'company_products',
        operators: ['any_includes_any', 'any_includes'],
      },
    ],
  },
  files_person: {
    AR: [
      { name: 'province', operators: ['in_custom_list'] },
      { name: 'main_activity', operators: ['includes_any'] },
      { name: 'main_activity_code', operators: ['includes_any'] },
      {
        name: 'activities_code',
        operators: ['any_includes_any', 'any_includes'],
      },
      {
        name: 'activities_description',
        operators: ['any_includes_any', 'any_includes'],
      },
      { name: 'is_pep', operators: ['is'], input: 'list' },
      { name: 'employment_status', operators: ['is_employment_status'] },
      {
        name: 'rejected_checks_causals',
        operators: ['any_in_rejected_checks', 'any_includes_any', 'any_includes', 'in_custom_list'],
        valueEditorType: 'select',
      },
      {
        name: 'debtor_classification_situations',
        operators: ['any_in_debtors_checks', 'any_includes_any', 'any_includes', 'in_custom_list'],
        valueEditorType: 'select',
      },
      {
        name: 'iva_inscription_condition',
        operators: ['equals', 'not_equals'],
      },
      {
        name: 'ganancias_inscription_condition',
        operators: ['equals', 'not_equals'],
      },
    ],
    BR: [
      {
        name: 'is_currently_pep',
        operators: ['is'],
      },
      {
        name: 'date_of_birth',
        operators: [
          'equals_number',
          'less_than_number',
          'greater_than_number',
          'between_inclusive_numbers',
          'between_exclusive_numbers',
        ],
      },
      {
        name: 'negative_media',
        operators: ['exists'],
      },
      {
        name: 'lawsuits_person',
        operators: ['any_includes', 'any_not_includes', 'any_includes_any', 'includes_any', 'any_not_equals'],
      },
      {
        name: 'lawsuits_person_amount',
        operators: [
          'less_than_number',
          'less_equal_than_number',
          'greater_than_number',
          'greater_equal_than_number',
          'between_inclusive_numbers',
          'between_exclusive_numbers',
        ],
      },
      {
        name: 'has_lawsuit_court_type_person',
        operators: ['any_includes', 'any_includes_any', 'any_in_custom_list', 'any_not_in_custom_list'],
        valueEditorType: 'select',
      },
      {
        name: 'area_codes_different_from_address',
        operators: ['is'],
      },
      {
        name: 'black_lists',
        operators: ['is'],
      },
      {
        name: 'history_sanctions',
        operators: ['any_in_sanctions', 'any_includes_any', 'any_includes', 'in_custom_list'],
      },
      {
        name: 'registration_status_name',
        operators: ['equals', 'includes', 'not_equals', 'any_not_in_list'],
      },
      {
        name: 'city',
        operators: ['in_custom_list_composed', 'not_in_custom_list_composed'],
      },
      {
        name: 'kyc_status',
        operators: ['equals', 'in_list'],
        valueEditorType: 'select',
        values: ['APPROVED', 'REJECTED', 'PENDING', 'FLAGGED'].map((status) => ({ name: status, value: status })),
      },
    ],
    CR: [
      {
        name: 'document_type',
        operators: ['equals', 'includes', 'in_list'],
      },
      {
        name: 'country_of_birth',
        operators: ['equals', 'in_custom_list', 'not_in_custom_list'],
      },
      {
        name: 'nationality',
        operators: ['equals', 'in_custom_list', 'not_in_custom_list'],
      },
      {
        name: 'address_state_city',
        operators: ['in_custom_list_composed'],
      },
      {
        name: 'profession_name',
        operators: ['equals', 'in_custom_list', 'not_in_custom_list'],
      },
      {
        name: 'income_name',
        operators: ['equals', 'in_custom_list', 'not_in_custom_list'],
      },
      {
        name: 'ocupation_name',
        operators: ['equals', 'in_custom_list', 'not_in_custom_list'],
      },
      {
        name: 'job_status_name',
        operators: ['equals', 'in_custom_list', 'not_in_custom_list'],
      },
      {
        name: 'job_bussiness_activity_name',
        operators: ['equals', 'in_custom_list', 'not_in_custom_list'],
      },
      {
        name: 'is_pep',
        operators: ['is'],
      },
      {
        name: 'is_reporting_entity',
        operators: ['is'],
      },
      {
        name: 'monthly_transactional_amount',
        operators: ['equals', 'in_custom_list', 'not_in_custom_list'],
      },
    ],
  },
}
